module.exports = __webpack_public_path__ + "./rain.0d05874e0f2cdd3a51985dd895f01fd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/rain.png
// module id = kCQN
// module chunks = app